import { cn } from "@kkp/app-kit";
import { scopeLabel } from "./reasons";

const STAGE_CLASS: Record<string, string> = {
  Open: "border-amber-500/45 bg-amber-500/15 text-amber-100",
  Acknowledged: "border-amber-500/45 bg-amber-500/15 text-amber-100",
  Escalated: "border-orange-500/45 bg-orange-500/15 text-orange-100",
  Blocked: "border-red-500/45 bg-red-500/15 text-red-100",
  Released: "border-emerald-500/45 bg-emerald-500/15 text-emerald-100",
  Rejected: "border-red-500/45 bg-red-500/15 text-red-100",
};

const PILL_BASE =
  "inline-flex items-center rounded-full border px-2.5 py-1 text-[11px] font-bold";

export function StagePill({ stage }: { stage: string }) {
  return (
    <span
      className={cn(
        PILL_BASE,
        STAGE_CLASS[stage] ?? "border-white/20 bg-white/10 text-white",
      )}
    >
      {stage}
    </span>
  );
}

export function ScopePill({ scope }: { scope: string }) {
  return (
    <span
      className={cn(
        PILL_BASE,
        "border-[color:rgba(203,72,226,0.45)] bg-[color:rgba(203,72,226,0.15)] text-white",
      )}
    >
      {scopeLabel(scope)}
    </span>
  );
}

export function OverdueBadge() {
  return (
    <span
      className={cn(PILL_BASE, "border-red-500/45 bg-red-500/15 text-red-100")}
    >
      Lewat tenggat
    </span>
  );
}
